import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  ["full_name", "Nome e cognome", "sm:col-span-2"],
  ["street", "Indirizzo e numero civico", "sm:col-span-2"],
  ["city", "Città", ""],
  ["zip", "CAP", ""],
  ["province", "Provincia", ""],
  ["notes", "Note per la consegna", ""],
];

export const emptyAddress = { full_name: "", street: "", city: "", zip: "", province: "", notes: "" };

export function AddressFields({ value, onChange, phone, setPhone }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {FIELDS.map(([k, label, cls]) => (
        <div key={k} className={cls}>
          <Label className="text-xs text-slate-400">{label}</Label>
          <Input data-testid={`address-${k}`} value={value[k]} onChange={(e) => onChange({ ...value, [k]: e.target.value })} className="mt-1 bg-[#1C1F2C]" />
        </div>
      ))}
      {setPhone && (
        <div className="sm:col-span-2">
          <Label className="text-xs text-slate-400">Cellulare (ricevi l'SMS di conferma)</Label>
          <Input data-testid="phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+39 333 1234567" className="mt-1 bg-[#1C1F2C]" />
        </div>
      )}
    </div>
  );
}
